import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="join-code-only"
// This is a simplified version of join_form_controller.js for already logged-in students
export default class extends Controller {
  static targets = ["codeStatus", "codeValid", "codeInvalid", "className", "classNameText"]
  
  async checkCode(event) {
    const code = event.target.value.trim()
    
    if (code.length < 3) {
      this.hideCodeStatus()
      this.hideClassName()
      return
    }
    
    try {
      const response = await fetch(`/check_join_code?code=${encodeURIComponent(code)}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      
      const data = await response.json()
      
      if (data.valid) {
        this.showValidCode()
        this.showClassName(data.class_name)
      } else {
        this.showInvalidCode()
        this.hideClassName()
      }
    } catch (error) {
      console.error("Error checking code:", error)
      this.hideCodeStatus()
      this.hideClassName()
    }
  }
  
  showValidCode() {
    this.codeStatusTarget.classList.remove("hidden")
    this.codeValidTarget.classList.remove("hidden")
    this.codeInvalidTarget.classList.add("hidden")
  }
  
  showInvalidCode() {
    this.codeStatusTarget.classList.remove("hidden")
    this.codeValidTarget.classList.add("hidden")
    this.codeInvalidTarget.classList.remove("hidden")
  }
  
  hideCodeStatus() {
    this.codeStatusTarget.classList.add("hidden")
    this.codeValidTarget.classList.add("hidden")
    this.codeInvalidTarget.classList.add("hidden")
  }
  
  showClassName(className) {
    this.classNameTarget.classList.remove("hidden")
    this.classNameTextTarget.textContent = className
  }
  
  hideClassName() {
    this.classNameTarget.classList.add("hidden")
    this.classNameTextTarget.textContent = ""
  }
}